import React from 'react';

import { CloudProviders } from '@ariksa/cloud-account/api';
import { Clients } from '@ariksa/notification';
import { Button, HStack, Box } from '@chakra-ui/react';
import capitalize from 'lodash/capitalize';
import isArray from 'lodash/isArray';
import map from 'lodash/map';

import { IdentityProviderName } from 'api/auth/api.pb';

export const getOptions = (data: {} | [], label?: string, value?: string) => {
  let options: { value: string; label: string }[] = [];

  if (isArray(data)) {
    map(data, each =>
      options.push({
        value: value ? each[value] : each,
        label: label ? each[label] : each,
      }),
    );
  } else {
    map(data, (value, key) => options.push({ value: key, label: value }));
  }
  return options;
};

export const getSeverityOptions = () => {
  let options: { value: string; label: string }[] = [];
  const severity = ['ALL', 'CRITICAL', 'MEDIUM', 'INFORMATIONAL'];
  map(severity, each => options.push({ value: each, label: capitalize(each) }));
  return options;
};

export const getButton = (
  isLoading: boolean,
  isDisabled: boolean,
  onClick: () => void,
) => {
  return (
    <HStack>
      <Button
        size="sm"
        isLoading={isLoading}
        isDisabled={isDisabled}
        onClick={onClick}
        variant="outline"
        colorScheme="blue"
      >
        Get
      </Button>
    </HStack>
  );
};

export const getHelperText = () => {
  return <Box>Click Here</Box>;
};

export const environments = [{ label: 'AWS', value: 'AWS' }];

export const isValidEmail = value => {
  const mailFormat = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return !!value.match(mailFormat);
};

export const getIntegrationsTitle = provider => {
  switch (provider) {
    case Clients.Elasticsearch:
      return 'Elastic';
    case Clients.Jira:
      return 'Jira';
    case Clients.Servicenow:
      return 'ServiceNow';
    case Clients.Slack:
      return 'Slack';
    case Clients.Teams:
      return 'Microsoft Teams';
    case Clients.Sns:
      return 'SMS';
    case IdentityProviderName.Okta:
      return 'Okta SSO';
    case IdentityProviderName.Google:
      return 'Google Workspace SSO';
    case IdentityProviderName.Microsoft:
      return 'Entra ID SSO';
    case CloudProviders.Okta:
      return 'Okta';
    case CloudProviders.AzureAd:
      return 'Entra ID';
    case Clients.Email:
      return 'Email Group';
    case CloudProviders.Snowflake:
      return 'Snowflake';
    case CloudProviders.Gitlab:
      return 'GitLab';
    case CloudProviders.Github:
      return 'GitHub';
    case CloudProviders.Bitbucket:
      return 'Bitbucket';
    case 'tableau':
      return 'Tableau';
  }
};

export const getIntegrationsSubTitle = provider => {
  switch (provider) {
    case Clients.Elasticsearch:
      return 'SIEM';
    case Clients.Jira:
    case Clients.Servicenow:
      return 'Ticketing';
    case Clients.Slack:
    case Clients.Teams:
    case Clients.Sns:
    case Clients.Email:
      return 'Notification';
    case IdentityProviderName.Okta:
    case IdentityProviderName.Google:
    case IdentityProviderName.Microsoft:
      return 'SSO';
    case CloudProviders.Okta:
    case CloudProviders.AzureAd:
      return 'Identity Provider';
    case CloudProviders.Snowflake:
      return 'Database';
    case CloudProviders.Gitlab:
    case CloudProviders.Github:
    case CloudProviders.Bitbucket:
      return 'Repository';
    case 'tableau':
      return 'Analytics';
  }
};

export const getFormTitle = provider => {
  switch (provider) {
    case Clients.Elasticsearch:
      return 'Elastic';
    case Clients.Jira:
      return 'Jira Project';
    case Clients.Servicenow:
      return 'ServiceNow Project';
    case Clients.Slack:
      return 'Slack Channel';
    case Clients.Teams:
      return 'Microsoft Teams';
    case Clients.Sns:
      return 'SMS';
    case IdentityProviderName.Okta:
      return 'Okta SSO';
    case IdentityProviderName.Google:
      return 'Google Workspace SSO';
    case IdentityProviderName.Microsoft:
      return 'Entra ID SSO';
    case CloudProviders.Okta:
      return 'Okta';
    case CloudProviders.AzureAd:
      return 'Entra ID';
    case Clients.Email:
      return 'Email Group';
    case CloudProviders.Snowflake:
      return 'Snowflake';
    case CloudProviders.Gitlab:
      return 'GitLab';
    case CloudProviders.Github:
      return 'GitHub';
    case CloudProviders.Bitbucket:
      return 'Bitbucket';
    case 'tableau':
      return 'Tableau';
  }
};
